export default __webpack_public_path__ + "static/media/doc-edit.c774bb64.svg";